import React, { useEffect, useState } from "react";
import { useUserContext} from "../contexts/user-context";
import QRCode from 'qrcode.react';
import {Button, ButtonGroup, Card, CardContent, CardHeader} from "@mui/material";
import {ModalWindow} from "./ModalWindow";
//var Password = Input.Password;

export const TwoFactorPrompt = () => {
    const userContext = useUserContext();
    const [code,setCode] = useState('');
    useEffect(()=>{
        userContext.getAuthenticatorCode(setCode);
    },[]);
    console.log('show 2fa?');
    return (
        <ModalWindow isOpen={true} onClose={()=>{return;}} header={
        "Two factor Authentication Code"
} actions={
            <Button onClick={(evt)=>{evt.preventDefault(); userContext.setMarked2Fa(true)}} variant="contained">Continue</Button>
} maxWidth="lg">
            <>
                <Card sx={(theme)=>({textAlign:'center'})}>
                    <CardHeader title={<>Scan this code into a compatible app for faster login</>}/>
                    <CardContent>
                        {code!='' &&
                            <QRCode value={code} size={256} />
                        }
                    </CardContent>
                </Card>
            </>
        </ModalWindow>
    );
}
